<pw-progress-bar *ngIf="totalQuantity >0"></pw-progress-bar>
<div *ngIf="!doesCartHaveDiscountLimitedUntilProduct" class="cart-title">
    <h2>{{ "shoppingCart.cartUpperCase" | translate }}</h2>
    <div [ngStyle]="{'display':'block','width':'100%'}" *ngFor="let deliveryOption of deliveryOptionsFreeList">
        <div *ngIf="totalPrice<=deliveryOption.freeDeliveryLimit!" class="free-delivery">
            <h3>Még {{(deliveryOption.freeDeliveryLimit! + 1)-totalPrice | currency : 'Ft' : 'symbol' : '1.0-0'}} értékű vásárlás esetén elengedjük a szállítási díjat {{ deliveryOption.name }} csomagautomatába történő szállításnál</h3>
        </div>
        <div *ngIf="totalPrice>deliveryOption.freeDeliveryLimit! && !separated" class="free-delivery">
            <h3>A szállítás ingyenes {{ deliveryOption.name }} esetén.</h3>
        </div>
    </div>
</div>
<div *ngIf="doesCartHaveDiscountLimitedUntilProduct" class="discount-limited-until-container">
    <h2>{{ "shoppingCart.cartUpperCase" | translate }}</h2>
    <div class="discount-limited-until">
        <b>A kosár kötött árú kiadványt tartalmaz: </b><br />
        <div
            [ngStyle]="discountLimitedMaterial.packageName ? { background: '#ededed','border-bottom':'2px solid #aaaaa9' } : { background: 'none' }"
            *ngFor="let discountLimitedMaterial of discountLimititedUntilMaterials; let i = index"
            class="cart-table"
        >
            <span *ngIf="discountLimitedMaterial.discountLimitedUntil!=null"
                >{{discountLimitedMaterial.author}} : {{discountLimitedMaterial.title}}</span
            ><br />
        </div>
    </div>
</div>
<div class="cartsum-container">
    <div
        [ngStyle]="material.packageName ? { background: '#ededed','border-bottom':'2px solid #aaaaa9' } : { background: 'none' }"
        *ngFor="let material of materials; let i = index"
        class="cart-table"
    >
        <table>
            <tr *ngIf="i===0">
                <th>{{ "shoppingCart.cover" | translate }}</th>
                <th>{{ "shoppingCart.author" | translate }}</th>
                <th>{{ "shoppingCart.title" | translate }}</th>
                <th>{{ "shoppingCart.onePrice" | translate }}</th>
                <th>{{ "shoppingCart.quantity" | translate }}</th>
                <th>{{ "shoppingCart.sum" | translate }}</th>
            </tr>
            <tr>
                <td>
                    <div class="cover">
                        <img src="{{material.url}}" />
                    </div>
                </td>
                <td>{{material.author}}</td>
                <td>
                    <div *ngIf="material.packageName" class="if-package">
                        <b> {{material.packageName}} csomag</b>
                    </div>
                    <div *ngIf="material.hasPreorder" class="if-package">
                        <b>Előrendelés</b>
                    </div>
                    <div *ngIf="material.hasPreorder" class="if-package">
                        <b>Várható megjelenés:</b>
                        <b>{{material.available | date}}</b>
                    </div>
                    <div>{{material.title}}</div>
                </td>
                <td>  <label *ngIf="material.discountLimitedUntil != null">Árkötött kiadvány </label
                    ><br />&nbsp;{{material.originalPrice | currency : 'Ft'
                    : 'symbol' : '1.0-0'}}
                </td>
                <td>
                    <div class="quantity">
                        <label *ngIf="!material.packageName">{{ "shoppingCart.quantitySumPiece" | translate }}</label>
                        <div *ngIf="!material.packageName" class="plus-minus-button">
                            <button (click)="decreaseItemQuantity(material)" class="minus-button">-</button>
                            <p>{{ material.quantity }}</p>
                            <button (click)="increaseItemQuantity(material)" class="plus-button">+</button>
                        </div>
                        <p *ngIf="material.packageName">{{ material.quantity }} db</p>
                        <div *ngIf="!material.packageName" class="delete">
                            <button class="delete-button" (click)="removeItem(material)">TÖRLÉS</button>
                        </div>
                    </div>
                </td>
                <td>
                    <div class="price">
                        <div class="close-icon">
                            <mat-icon (click)="loadRemovePackagePopup(material,'500ms','200ms')" *ngIf="material.firstElementOfPackage"
                                >close</mat-icon
                            >
                            <!-- <div class="show-package-delete">
                                <p>CSOMAGOK TÖRLÉSE</p>
                            </div> -->
                        </div>

                        <div class="pricee">
                          <label>{{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' : '1.0-0'}}</label>
                        </div>
                        <!-- <div class="placeholder"></div>-->
                    </div>
                </td>
            </tr>
        </table>
    </div>
    <div class="cart-and-sum">
        <div class="sum">
            <h3>{{"shoppingCart.total" | translate}}:</h3>
            <h3>{{ totalPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</h3>
        </div>
    </div>
    <div *ngIf="materials.length>=2 && hasMaterialPreorder()">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="separatedOption">
            <p [ngStyle]="{'font-weight':'bold'}">Összevárom a rendelésemet:</p>
            <div class="simple-container">
                <mat-radio-button (click)="clickOnUnSeparated()" class="example-radio-button" value="UNSEPARATED">
                    <h4>{{"shoppingCart.unseparated" | translate}}</h4>
                </mat-radio-button>
            </div>
            <p [ngStyle]="{'font-weight':'bold'}">Külön kérem a rendelésemet:</p>
            <mat-radio-button (click)="clickOnSeparated()" class="example-radio-button" value="SEPARATED">
                <h4>{{"shoppingCart.separated" | translate}}</h4>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <p [ngStyle]="{'color':'red'}">{{chooseSeparationMessage}}</p>
    <div class="back-and-to-buttons">
        <div class="buttons">
            <button routerLink="/book">{{"shoppingCart.backToMaterials" | translate}}</button>
            <button (click)="goToContact()">{{"shoppingCart.toPersonalDatas" | translate}}</button>
        </div>
    </div>
</div>

<div class="cartsum-container-mobile">
    <div *ngFor="let material of materials; let i = index" class="table-cart">
        <table [ngStyle]="{backgroundColor: i%2 === 0 ? 'white' : '#e8fcfd'}">
            <tr>
                <td>
                    <img src="{{material.url}}" />
                    <div class="title-author">
                        <div *ngIf="material.hasPreorder" class="book-data">
                            <b>Előrendelés</b><br />
                            <b>Várható megjelenés:</b><br />
                            <b>{{material.available | date}}</b><br />
                            <label>{{material.author}}</label><br />
                            <label>{{material.title}}</label><br />
                        </div>
                        <div *ngIf="material.packageName" class="book-data">
                            <b>{{material.packageName}} csomag</b><br />
                            <label>{{material.author}}</label><br />
                            <label>{{material.title}}</label><br />
                        </div>
                        <div *ngIf="!material.packageName && !material.hasPreorder" class="book-data">
                            <label>{{material.author}}</label><br />
                            <label>{{material.title}}</label><br />
                        </div>
                        <span *ngIf="material.packageName">{{ material.quantity }} db</span>
                    </div>
                    <div class="delete-button">
                        <mat-icon *ngIf="!material.packageName" class="delete-button" (click)="removeItem(material)"
                            >delete_forever</mat-icon
                        >
                        <mat-icon
                            *ngIf="material.packageName"
                            class="delete-button"
                            (click)="loadRemovePackagePopup(material,'500ms','200ms')"
                            >delete_forever</mat-icon
                        >
                    </div>
                </td>
            </tr>
            <tr>
                <td *ngIf="!material.packageName">
                    <div class="plus-minus-button">
                        <button (click)="decreaseItemQuantity(material)" class="minus-button">-</button>
                        <p>{{ material.quantity }}</p>
                        <button (click)="increaseItemQuantity(material)" class="plus-button">+</button>
                    </div>
                    <label
                        >  <label *ngIf="material.discountLimitedUntil != null">Árkötött kiadvány </label
                            ><br />&nbsp;{{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' : '1.0-0'}}</label
                    ><br />
                </td>
                <td [ngStyle]="{'display':'flex','width':'100%','justify-content':'flex-end'}" *ngIf="material.packageName">
                    <label [ngStyle]="{'padding':'16px'}">
                       {{material.originalPrice!*material.quantity! | currency : 'Ft' : 'symbol' : '1.0-0'}}</label
                    ><br />
                </td>
            </tr>
        </table>
    </div>
    <div class="cart-and-sum">
        <div class="sum">
            <div class="cart-total">
                <h4>{{"shoppingCart.total" | translate}}</h4>
                <h4>{{ totalPrice | currency : 'Ft' : 'symbol' : '1.0-0' }}</h4>
            </div>
        </div>
    </div>
    <div *ngIf="materials.length>=2 && hasMaterialPreorder()">
        <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group" [(ngModel)]="separatedOption">
            <p [ngStyle]="{'font-weight':'bold'}">Összevárom a rendelésemet:</p>
            <div class="simple-container">
                <mat-radio-button (click)="clickOnUnSeparated()" class="example-radio-button" value="UNSEPARATED">
                    <h4>{{"shoppingCart.unseparated" | translate}}</h4>
                </mat-radio-button>
            </div>
            <p [ngStyle]="{'font-weight':'bold'}">Nem várom össze a rendelésemet:</p>
            <mat-radio-button (click)="clickOnSeparated()" class="example-radio-button" value="SEPARATED">
                <h4>{{"shoppingCart.separated" | translate}}</h4>
            </mat-radio-button>
        </mat-radio-group>
    </div>
    <p [ngStyle]="{'color':'red'}">{{chooseSeparationMessage}}</p>
    <div class="back-and-to-buttons">
        <button routerLink="/book">{{"shoppingCart.backToMaterials" | translate}}</button>
        <button (click)="goToContact()">{{"shoppingCart.toPersonalDatas" | translate}}</button>
    </div>
</div>
